module.exports = __webpack_public_path__ + "static/img/sfcta-logo.c8e8f64.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sfcta-logo.png
// module id = e/pS
// module chunks = 1